<!-- No country, no band. An empty blue strip with stars and no letter claims an EU registration
     we have not been told about — see the `euBand` default. -->
@if (hasBand()) {
<span class="lp__band" aria-hidden="true">
  <!-- Ring of twelve stars, drawn rather than typed: the ★ glyph renders at wildly different
       weights across platforms and looked like a bullet on Windows. -->
  <svg class="lp__stars" viewBox="0 0 24 24" focusable="false">
    <g fill="#ffcc00">
      @for (star of stars; track star) {
      <circle [attr.cx]="12 + 8 * cos(star)" [attr.cy]="12 + 8 * sin(star)" r="1.1" />
      }
    </g>
  </svg>
  <span class="lp__cc">{{ euBand() }}</span>
</span>
}

<span class="lp__field">
  @if (editable()) {
  <!-- The caller's <input> lives here, so it inherits the plate's frame, band and tribands. -->
  <ng-content />
  } @else if (hasRegion()) {
  <span class="lp__text">{{ parts().region }}</span>
  @if (showEmblem()) {
  <!-- The region's own arms — the Bundesland's on an Austrian plate, from the spreadsheet Albert
       supplied. Never the national flag: see at-districts.ts. Width follows the artwork's own
       aspect ratio, since real arms are not square and squashing them looks wrong.
       No arms for this region means no split at all: `parts()` has already merged the halves. -->
  <img class="lp__arms" [src]="arms()!.src" [alt]="arms()!.name"
    [style.width.em]="arms()!.ratio" />
  } @else {
  <span class="lp__text lp__text--dash" aria-hidden="true">-</span>
  }
  <span class="lp__text">{{ parts().rest }}</span>
  } @else {
  <span class="lp__text" [class.lp__text--placeholder]="isPlaceholder()">{{ display() }}</span>
  }
</span>
